// extracted by mini-css-extract-plugin
export default {"overlay":"iA-z","bodyOpen":"jA-z","content":"kA-z","header":"lA-z","close":"mA-z","closeNoHeading":"nA-z"};